import React, { useContext, useEffect, useState } from 'react';
import FeatureConfig from '../config/FeaturesConfig';
import DataSource from '../api';
import Naws from '../api/Naws';
import { StateContext } from '../GlobalStateStore';
import DataState from '../Types/DataState';
import Storage from '../Util/Storage';
import { ProxyStorageKeys } from '../hooks/useProxy';
import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';
import PerformancePortalLanding from './PerformancePortalLanding';
import { awsRum } from '../config/cloudWatchRUM';
import { usePeriodicCacheReset } from '../api/AppSyncClient';
import { checkGoUser } from '../Util/User';
import useStrippedPath from '../hooks/useStrippedPath';

// wrapper component to ensure FeatureConfig is loaded before rendering app
const PerformancePortalContainer = () => {
  const apiNaws = DataSource.getDataFeed('NAWS') as typeof Naws;

  const globalState = useContext(StateContext);

  const [inspireOptionsError, setInspireOptionsError] = useState(false);
  const [featuresConfigLoaded, setFeaturesConfigLoaded] = useState(false);

  // clear our apollo cache every 30 mins
  usePeriodicCacheReset();

  const strippedPath = useStrippedPath();
  React.useEffect(() => {
    awsRum?.recordPageView(strippedPath);
  }, [strippedPath]);

  useEffect(() => {
    async function onLoad(): Promise<void> {
      // Check if we're in proxy mode and use proxy user ID
      const proxyUserId = Storage.getItem(ProxyStorageKeys.PROXY_USER_ID);
      const userIdToUse = proxyUserId ?? undefined;

      await apiNaws.getInspireOptions((resp: any) => {
        if (!resp || !resp.payload || resp.payload.state === DataState.ERROR) {
          setInspireOptionsError(true);
        } else {
          setInspireOptionsError(false);
          globalState.dispatch(resp);
        }
      }, userIdToUse);
    }
    onLoad();
  }, []);

  useEffect(() => {
    async function onLoad(userId: string): Promise<void> {
      await FeatureConfig.refreshConfig(userId);
      setFeaturesConfigLoaded(true);
    }

    const inspireOptions = globalState.state.inspireOptions.data;

    if (inspireOptions.userID) {
      onLoad(inspireOptions.userID);

      // set additional cloudwatch RUM metadata
      awsRum?.addSessionAttributes({
        requesterUserID: inspireOptions.requesterUserID,
        alias: inspireOptions.requesterUsername,
        isGo: checkGoUser(inspireOptions.requesterOwner),
        isTm: inspireOptions.isTm,
        isOm: inspireOptions.isOm,
        isExclusivelyOm: inspireOptions.isExclusivelyOm,
        isExclusivelyTm: inspireOptions.isExclusivelyTm,
      });
    }
  }, [globalState.state.inspireOptions.data]);

  if (!featuresConfigLoaded && !inspireOptionsError) {
    return (
      <Row alignmentHorizontal='center' spacingInset='500'>
        <Loader />
      </Row>
    );
  }

  return <PerformancePortalLanding inspireOptionsError={inspireOptionsError} />;
};

export default PerformancePortalContainer;
